import React, { Suspense } from "react";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { createRoot } from "react-dom/client";
import TagManager from "react-gtm-module";
import App from "./App";
import Store from "./store";
import "./assets/css/index.css";
import "./assets/css/app.css";
import "./assets/scss/style.scss";
import Spinner from "./views/spinner/spinner";

Sentry.init({
  dsn:
    process.env.REACT_APP_SERVER_ENV === "development"
      ? null
      : "https://4c123395550e45709a6904d636ebeb0a@o4504220604760064.ingest.sentry.io/4504223785549824",
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

const root = createRoot(document.getElementById("root"));
const tagManagerArgs = {
  gtmId: "GTM-WJCBQDPS", // Replace with your GTM ID
};

TagManager.initialize(tagManagerArgs);
root.render(
  <Provider store={Store}>
    <Suspense fallback={<Spinner />}>
      <App />
    </Suspense>
  </Provider>,
);

console.log(process.env.NODE_ENV);
console.log(process.env.REACT_APP_SERVER_ENV);
